module.exports = __webpack_public_path__ + "img/animation_cloudy.069422d3.gif";